export const movingPositions = {
  1: {
    1: [
      {
        plotX: 257,
        plotY: 223
      }
    ],
    2: [
      {
        plotX: 99,
        plotY: 237
      }
    ],
    3: [
      {
        plotX: 198,
        plotY: 8
      }
    ]
  },
  2: {
    1: [
      {
        plotX: 142,
        plotY: 170
      },
      {
        plotX: 277,
        plotY: 198
      }
    ],
    2: [
      {
        plotX: 283,
        plotY: 101
      },
      {
        plotX: 134,
        plotY: 268
      }
    ],
    3: [
      {
        plotX: 238,
        plotY: 355
      },
      {
        plotX: 182,
        plotY: 13
      }
    ]
  },
  3: {
    1: [
      {
        plotX: 280,
        plotY: 191
      },
      {
        plotX: 168,
        plotY: 242
      },
      {
        plotX: 180,
        plotY: 120
      }
    ],
    2: [
      {
        plotX: 286,
        plotY: 266
      },
      {
        plotX: 100,
        plotY: 211
      },
      {
        plotX: 241,
        plotY: 71
      }
    ],
    3: [
      {
        plotX: 219,
        plotY: 357
      },
      {
        plotX: 56,
        plotY: 103
      },
      {
        plotX: 353,
        plotY: 87
      }
    ]
  },
  4: {
    1: [
      {
        plotX:  241,
        plotY: 246
      },
      {
        plotX: 147,
        plotY: 216
      },
      {
        plotX: 177,
        plotY: 122
      },
      {
        plotX: 271,
        plotY: 152
      }
    ],
    2: [
      {
        plotX: 323,
        plotY: 191
      },
      {
        plotX: 202,
        plotY: 299
      },
      {
        plotX: 112,
        plotY: 122
      },
      {
        plotX: 271,
        plotY: 88
      }
    ],
    3: [
      {
        plotX: 355,
        plotY: 278
      },
      {
        plotX: 115,
        plotY: 327
      },
      {
        plotX: 35,
        plotY: 175
      },
      {
        plotX: 218,
        plotY: 10
      }
    ]
  },
  5: {
    1: [
      {
        plotX: 274,
        plotY: 202
      },
      {
        plotX: 212,
        plotY: 252
      },
      {
        plotX: 146,
        plotY: 209
      },
      {
        plotX: 166,
        plotY: 132
      },
      {
        plotX: 245,
        plotY: 128
      }
    ],
    2: [
      {
        plotX: 261,
        plotY: 287
      },
      {
        plotX: 146,
        plotY: 281
      },
      {
        plotX: 94,
        plotY: 178
      },
      {
        plotX: 215,
        plotY: 70
      },
      {
        plotX: 311,
        plotY: 132
      }
    ],
    3: [
      {
        plotX: 381,
        plotY: 192
      },
      {
        plotX: 358,
        plotY: 272
      },
      {
        plotX: 73,
        plotY: 290
      },
      {
        plotX: 41,
        plotY: 137
      },
      {
        plotX: 157,
        plotY: 16
      }
    ]
  },
  6: {
    1: [
      {
        plotX: 279,
        plotY: 159
      },
      {
        plotX: 263,
        plotY: 226
      },
      {
        plotX: 171,
        plotY: 243
      },
      {
        plotX: 141,
        plotY: 193
      },
      {
        plotX: 156,
        plotY: 132
      },
      {
        plotX: 220,
        plotY: 108
      }
    ],
    2: [
      {
        plotX: 325,
        plotY: 191
      },
      {
        plotX: 269,
        plotY: 283
      },
      {
        plotX: 162,
        plotY: 290
      },
      {
        plotX: 99,
        plotY: 150
      },
      {
        plotX: 174,
        plotY: 74
      },
      {
        plotX: 280,
        plotY: 93
      }
    ],
    3: [
      {
        plotX: 358,
        plotY: 270
      },
      {
        plotX: 219,
        plotY: 357
      },
      {
        plotX: 70,
        plotY: 292
      },
      {
        plotX: 72,
        plotY: 77
      },
      {
        plotX: 246,
        plotY: 13
      },
      {
        plotX: 368,
        plotY: 117
      }
    ]
  },
  7: {
    1: [
      {
        plotX: 281,
        plotY: 185
      },
      {
        plotX: 241,
        plotY: 246
      },
      {
        plotX: 199,
        plotY: 257
      },
      {
        plotX: 147,
        plotY: 216
      },
      {
        plotX: 153,
        plotY: 134
      },
      {
        plotX: 212,
        plotY: 114
      },
      {
        plotX: 251,
        plotY: 124
      }
    ],
    2: [
      {
        plotX: 308,
        plotY: 243
      },
      {
        plotX: 216,
        plotY: 299
      },
      {
        plotX: 162,
        plotY: 290
      },
      {
        plotX: 119,
        plotY: 255
      },
      {
        plotX: 99,
        plotY: 150
      },
      {
        plotX: 174,
        plotY: 74
      },
      {
        plotX: 314,
        plotY: 137
      }
    ],
    3: [
      {
        plotX: 381,
        plotY: 193
      },
      {
        plotX: 300,
        plotY: 329
      },
      {
        plotX: 83,
        plotY: 310
      },
      {
        plotX: 36,
        plotY: 213
      },
      {
        plotX: 90,
        plotY: 58
      },
      {
        plotX: 244,
        plotY: 14
      },
      {
        plotX: 320,
        plotY: 52
      }
    ]
  },
  8: {
    1: [
      {
        plotX: 281,
        plotY: 185
      },
      {
        plotX: 241,
        plotY: 246
      },
      {
        plotX: 199,
        plotY: 257
      },
      {
        plotX: 147,
        plotY: 216
      },
      {
        plotX: 139,
        plotY: 181
      },
      {
        plotX: 167,
        plotY: 125
      },
      {
        plotX: 212,
        plotY: 114
      },
      {
        plotX: 252,
        plotY: 126
      }
    ],
    2: [
      {
        plotX: 308,
        plotY: 243
      },
      {
        plotX: 219,
        plotY: 303
      },
      {
        plotX: 157,
        plotY: 295
      },
      {
        plotX: 113,
        plotY: 257
      },
      {
        plotX: 99,
        plotY: 150
      },
      {
        plotX: 174,
        plotY: 74
      },
      {
        plotX: 295,
        plotY: 107
      },
      {
        plotX: 318,
        plotY: 140
      }
    ],
    3: [
      {
        plotX: 368,
        plotY: 217
      },
      {
        plotX: 304,
        plotY: 312
      },
      {
        plotX: 122,
        plotY: 316
      },
      {
        plotX: 49,
        plotY: 213
      },
      {
        plotX: 91,
        plotY: 72
      },
      {
        plotX: 238,
        plotY: 25
      },
      {
        plotX: 302,
        plotY: 47
      },
      {
        plotX: 340,
        plotY: 82
      },
    ]
  },
  9: {
    1: [],
    2: [
      {
        plotX: 315,
        plotY: 217
      },
      {
        plotX: 266,
        plotY: 279
      },
      {
        plotX: 190,
        plotY: 295
      },
      {
        plotX: 122,
        plotY: 255
      },
      {
        plotX: 97,
        plotY: 187
      },
      {
        plotX: 124,
        plotY: 110
      },
      {
        plotX: 184,
        plotY: 74
      },
      {
        plotX: 263,
        plotY: 85
      },
      {
        plotX: 312,
        plotY: 149
      }
    ],
    3: [
      {
        plotX: 358,
        plotY: 175
      },
      {
        plotX: 335,
        plotY: 260
      },
      {
        plotX: 252,
        plotY: 330
      },
      {
        plotX: 149,
        plotY: 326
      },
      {
        plotX: 70,
        plotY: 252
      },
      {
        plotX: 60,
        plotY: 148
      },
      {
        plotX: 122,
        plotY: 60
      },
      {
        plotX: 216,
        plotY: 24
      },
      {
        plotX: 318,
        plotY: 74
      },
    ]
  }
};